// extracted by mini-css-extract-plugin
module.exports = {"sliderArrow":"slider-arrow_sliderArrow__OBchT"};